import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button, Spinner, Alert } from "react-bootstrap";
import api from "../../../axiosConfig";
import "./css/StockHistoryPakaiTab.css";

export default function StockHistoryPakaiTab() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const stockItemId = searchParams.get("stock_item_id");

  useEffect(() => {
    if (stockItemId) fetchPemakaian();
  }, [stockItemId]);

  const fetchPemakaian = async () => {
    try {
      setLoading(true);

      // Ambil data pemakaian (sudah termasuk part_name & spesifikasi)
      const res = await api.get("/stock-items/history-pemakaian", {
        params: { stock_item_id: stockItemId },
      });

      const pemakaian = Array.isArray(res.data)
        ? res.data
        : res.data?.data || [];

      // Mapping data untuk tabel
      const mapped = pemakaian.map((r) => ({
        id: r.id,
        tanggal: r.created_at,
        nama_barang: r.nama_barang,
        part_number: r.part_number || "-", // <-- sekarang sudah ada dari backend
        qty: r.qty_dipakai ?? "-",
        mesin: r.mesin ?? "-",
        petugas: r.petugas ?? "-",
        note: r.keterangan ?? "-",
      }));

      setRows(mapped);
    } catch (err) {
      console.error(err);
      setError("Gagal mengambil data pemakaian stock");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shortlife-container">
      <div className="header-bar mb-3">
        <h2>HISTORY PEMAKAIAN STOCK ITEM</h2>
        <Button variant="danger" onClick={() => navigate(-1)}>
          ← Kembali
        </Button>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      {loading ? (
        <div className="text-center p-3">
          <Spinner animation="border" />
        </div>
      ) : (
        <div className="table-wrapper">
          <table className="preview-table">
            <thead>
              <tr>
                <th>No</th>
                <th>Tanggal</th>
                <th>Part Name</th>
                <th>Part Number</th>
                <th>Qty Dipakai</th>
                <th>Mesin</th>
                <th>PIC</th>
                <th>Keterangan</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan="8" className="empty">
                    Data pemakaian belum ada
                  </td>
                </tr>
              ) : (
                rows.map((d, i) => (
                  <tr key={d.id || i}>
                    <td className="center">{i + 1}</td>
                    <td className="center">
                      {d.tanggal
                        ? new Date(d.tanggal).toLocaleDateString("id-ID", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : "-"}
                    </td>
                    <td className="bold center">{d.nama_barang}</td>
                    <td className="center">{d.part_number}</td>
                    <td className="center">{d.qty}</td>
                    <td className="center">{d.mesin}</td>
                    <td className="center">{d.petugas}</td>
                    <td className="text-start">{d.note}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
